// extracted by mini-css-extract-plugin
export var container = "components-account-data-tables-__DataTableZeroState-module___container";
export var text = "components-account-data-tables-__DataTableZeroState-module___text";